import { HTTPAction } from '../helpers/constants';
import { IFetchOptions, IHttpActionOptions } from '../interfaces';
import { HttpMethod } from '../types';
import FetchClientService from './fetchClient.service';

export default class FetchService {
    static sendRequest(
        endpoint: string,
        body: unknown,
        options: IFetchOptions,
    ) {
        return FetchClientService.httpAction(
            options.method as HttpMethod,
            endpoint,
            body,
            options,
        );
    }

    static get(endpoint: string, options: IHttpActionOptions) {
        return FetchService.sendRequest(endpoint, null, {
            ...options,
            method: HTTPAction.GET,
        });
    }

    static post(endpoint: string, body: unknown, options: IHttpActionOptions) {
        return FetchService.sendRequest(endpoint, body, {
            ...options,
            method: HTTPAction.POST,
        });
    }

    static put(endpoint: string, body: unknown, options: IHttpActionOptions) {
        return FetchService.sendRequest(endpoint, body, {
            ...options,
            method: HTTPAction.PUT,
        });
    }

    static patch(endpoint: string, body: unknown, options: IHttpActionOptions) {
        return FetchService.sendRequest(endpoint, body, {
            ...options,
            method: HTTPAction.PATCH,
        });
    }

    static delete(
        endpoint: string,
        body: unknown,
        options: IHttpActionOptions,
    ) {
        return FetchService.sendRequest(endpoint, body, {
            ...options,
            method: HTTPAction.DELETE,
        });
    }
}
